
import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faBars, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";
import img1 from "../../Images/uniluslogo1.png";
import "./NavBar.css";
import useAuth from '../Hooks/UseAuth';
import axios from 'axios';

function NavBar() {
    const [visible, setVisible] = useState(false);
    const [navDrop, setnavDrop] = useState(false);
    const [logout, setLogout] = useState(false);
    const [loading, setLoading] = useState(false);
    const [navDropSec, setnavDropSec] = useState(false);
    const { auth, setAuth } = useAuth();
    const [scrollState, setScrollState] = useState(false);

    useEffect(() => {
        let listener = document.addEventListener("scroll", e => {
            var scrolled = document.scrollingElement.scrollTop;
            if (scrolled >= 120) {
                if (scrollState !== true) setScrollState(true);
            } else {
                if (scrollState !== false) setScrollState(false);
            }
        });
        return () => {
            document.removeEventListener("scroll", listener);
        };
    }, [scrollState]);

    const HandleDrop = () => {
        setnavDrop(prev => !prev);
    };

    const HandleSecDrop = () => {
        setnavDropSec(prev => !prev);
    };

    const HandleLogout = async () => {
        try {
            setLoading(true);
            await axios.post(
                process.env.REACT_APP_BASEURL + '/api/auth/logout',
                { UserID: auth?.UserID },
                { withCredentials: true }
            );
            setAuth({});
        } catch (error) {
            alert(error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className={scrollState ? "scrollCover" : "NavWhole"}>
                <div className='resNav'>
                    <div className='logo'>
                        <Link to={"/"} className='linkItem'>
                            <img src={img1} alt="Logo" />
                        </Link>
                    </div>
                    <div className='toggle' onClick={HandleSecDrop}>
                        {navDropSec ?
                            <FontAwesomeIcon className="fontawesomIcons" icon={faTimes} /> :
                            <FontAwesomeIcon className="fontawesomIcons" icon={faBars} />
                        }
                    </div>
                </div>

                <div className='listItems'>
                    <div className='firstItem'>
                        <ul>
                            <li>
                                <div className='logo'>
                                    <Link to={"/"} className='linkItem'>
                                        <img src={img1} alt="Logo" />
                                    </Link>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div className='secItem'>
                    <ul>
                    <ul>
                        <li className='serviceItem'><NavLink to={"/Courseswhole"} className='linkItem' activeClassName="active">Courses</NavLink></li>
                        <li className='serviceItem'><NavLink to={"/Organisations"} className='linkItem' activeClassName="active">Tailored-Courses</NavLink></li>
                        {auth.user && <li className='serviceItem'><NavLink to={"/Home"} className='linkItem' activeClassName="active">Dashboard</NavLink></li>}
                        <li className='serviceItem'><NavLink to={"/MoreInfo"} className='linkItem' activeClassName="active">More Info</NavLink></li>
                        <li className='serviceItem'><NavLink to={"/payment"} className='linkItem' activeClassName="active">Payments</NavLink></li>
                        {auth?.Role === 'Admin' && <li className='serviceItem'><NavLink to={"/admin/applicants"} className='linkItem' activeClassName="active">Admin</NavLink></li>}
                    </ul>
                        {/* <li className='serviceItem'><NavLink to={"/Courseswhole"} className='linkItem' activeClassName="active">Courses</NavLink></li>
                        <li className='serviceItem'><NavLink to={"/Organisations"} className='linkItem' activeClassName="active">Tailored-Courses</NavLink></li>
                        {auth.user && <li className='serviceItem'><NavLink to={"/Home"} className='linkItem' activeClassName="active">Dashboard</NavLink></li>}
                        <li className='serviceItem'><NavLink to={"/MoreInfo"} className='linkItem' activeClassName="active">More Info</NavLink></li>
                        <li className='serviceItem'><NavLink to={"/payment"} className='linkItem' activeClassName="active">Payments</NavLink></li>
                        {auth?.Role === 'Admin' && <li className='serviceItem'><NavLink to={"/admin/applicants"} className='linkItem' activeClassName="active">Admin</NavLink></li>} */}
                    </ul>
                        {/* <ul>
                            <li className='serviceItem'><Link to={"/Courseswhole"} className='linkItem'>Courses</Link></li>
                            <li className='serviceItem'><Link to={"/Organisations"} className='linkItem'>Tailored-Courses</Link></li>
                            {auth.user &&
                            <li className='serviceItem'><Link to={"/Home"} className='linkItem'>Dashboard</Link></li>}
                            <li className='serviceItem'><Link to={"/MoreInfo"} className='linkItem'>More Info</Link></li>
                            <li className='serviceItem'><Link to={"/payment"} className='linkItem'>Payments</Link></li>
                            {auth?.Role === 'Admin' &&
                                <li className='serviceItem'><Link to={"/admin/applicants"} className='linkItem'>Admin</Link></li>
                            }
                        </ul> */}
                    </div>
                    <div className='thirdItem'>
                        <li>
                            <div className='buttons'>
                                {auth.user ?
                                    <div className="loggedBtn">
                                        <h3 onClick={() => { setLogout(!logout) }}>
                                            {String(auth?.FName)}
                                            <FontAwesomeIcon className='fontLogoutICon' icon={faChevronDown} />
                                        </h3>
                                        {logout &&
                                            <div className='logoutBtn'>
                                                <p><Link to={'/profile'} className='listItem'>Profile |</Link></p>
                                                <p onClick={() => HandleLogout()}>LOGOUT</p>
                                            </div>
                                        }
                                    </div>
                                    :
                                    <Link to={"/login"} className='linkItem'><button>LOGIN</button></Link>
                                }
                            </div>
                        </li>
                    </div>
                </div>

                <div className={navDrop ? 'dropView' : "noDrop"}></div>

                {/* Responsive dropdown menu */}
                <div className={navDropSec ? 'SecResDrop' : "noSecDrop"}>
                    <div className='secDropCover'>
                        <ul>
                            <li><Link to={"/Courseswhole"} className='linkItem'>Courses</Link></li>
                            <li><Link to={"/Organisations"} className='linkItem'>Tailored-Courses</Link></li>
                            {auth.user &&
                            <li><Link to={"/Home"} className='linkItem'>Dashboard</Link></li>}
                            <li><Link to={"/MoreInfo"} className='linkItem'>More Info</Link></li>
                            <li><Link to={"/MoreInfo"} className='linkItem'>Payments</Link></li>
                            {auth?.Role === 'Admin' &&
                                <li><Link to={"/admin/applicants"} className='linkItem'>Admin</Link></li>
                            }
                            {auth.user ?
                                <>
                                    <li><Link to={'/profile'} className='linkItem'>Profile</Link></li>
                                    <li onClick={() => HandleLogout()}>Logout</li>
                                </>
                                :
                                <li><Link to={"/login"} className='linkItem'>LOGIN</Link></li>
                            }

                            <li><Link to={"/login"} className='linkItem'><button>APPLY NOW</button></Link></li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
}

export default NavBar;



// import React, {useState,useEffect} from 'react';
// import { FontAwesomeIcon, } from '@fortawesome/react-fontawesome';
// import { fab,faFacebook, faTwitter,faInstagram,faYoutube, faLinkedin, faArrowDown, faChevronDown } from '@fortawesome/free-solid-svg-icons'
// import {faHeart,faPhone,faLocationPin,faTools,faUserShield ,faTimes,faBars } from '@fortawesome/free-solid-svg-icons'
// import { Link } from "react-router-dom";
// // import img1 from  "../../Images/UnilusPNG3.png"
// // import img1 from  "../../Images/UnilusLogo.PNG"
// import img1 from  "../../Images/uniluslogo1.png"


// import "./NavBar.css"
// import useAuth from '../Hooks/UseAuth';
// import axios from 'axios';


// function NavBar() { 

//     const [ visible, setVisible] = useState(false); 
//     const [ navDrop, setnavDrop] = useState(false); 
//     const [ logout, setLogout] = useState(false); 
//     const [ loading, setLoading] = useState(false); 
//     const [ navDropSec, setnavDropSec] = useState(false); 
//      const {auth,setAuth} = useAuth()

//     let listener = null
//     const [scrollState, setScrollState] = useState(false)


//     //Changes NavBar color when you scroll over 120 pixels
//     useEffect(() => {
//       listener = document.addEventListener("scroll", e => {
//         var scrolled = document.scrollingElement.scrollTop
//         if (scrolled >= 120) {
//           if (scrollState !== true) setScrollState(true)
//         } else {
//           if (scrollState !== false) setScrollState(false)
//         }
//       })
//       return () => {
//         document.removeEventListener("scroll", listener)
//       }
//     }, [scrollState])


//     // <div className='toggle' onClick={HandleDrop}>
//     const HandleDrop = () =>{
//         setnavDrop(prev => !prev)
//     }
//     const HandleSecDrop = () =>{
//         setnavDropSec(prev => !prev)
      
//     }

//     // const HandleLogout = async () => {
     
     
//     //     try {
//     //         setLoading(true)
//     //       await axios.post(process.env.REACT_APP_BASEURL + '/api/auth/logout', {
//     //         withCredentials: true,
//     //         params: { UserID: auth?.UserID }
           
//     //       });
//     //       setAuth({})
//     //       //setStudents(updatedStudents);
//     //     } catch (error) {
//     //       alert(error.message);
//     //     } finally {
//     //       setLoading(false);
//     //     }
      
//     // };
//     const HandleLogout = async () => {
//         try {
//           setLoading(true);
//           await axios.post(
//             process.env.REACT_APP_BASEURL + '/api/auth/logout',
//             { UserID: auth?.UserID },
//             { withCredentials: true }
//           );
//           setAuth({});
//           // setStudents(updatedStudents);
//         } catch (error) {
//           alert(error.message);
//         } finally {
//           setLoading(false);
//         }
//       };
      
  
    
 

//   return <>
    
//     {/* <div className='NavWhole'> */}
    
//     <div className={scrollState? "scrollCover": "NavWhole"}>

//             <div className='resNav'>
//                         <div className='logo'>
//                                  {/* <h1>Twalumba</h1> */}
//                                  {/* <img src={img1}></img> */}
//                                  <Link to={"/"} className='linkItem'>
//                                          <img src={img1}></img>
//                                     {/* <button>BOOK NOW</button> */}
//                                     </Link>
                                

//                              </div>
                        
//                              <div className='toggle' onClick={HandleSecDrop}>
//                              {navDropSec ?
//                                <FontAwesomeIcon className="fontawesomIcons" icon={faTimes} />:
//                                <FontAwesomeIcon className="fontawesomIcons" icon={faBars} />
//                             }
//                                {/* <FontAwesomeIcon className="fontawesomIcons" icon={faBars} /> */}
//                         </div>

//             </div>

               
                 
//                 <div className='listItems'>

//                     <div className='firstItem'>
//                     <ul>
//                         <li>
//                              <div className='logo'>
                               
//                                  <Link to={"/"} className='linkItem'>
//                                          <img src={img1}></img>
//                                     {/* <button>BOOK NOW</button> */}
//                                     </Link>
                                  

//                              </div>
//                         </li>
//                     </ul>

//                     </div>
//                     <div className='secItem'> 

//                             <ul>

//                             <li>
//                                 <div className='toggle' onClick={HandleDrop}>
//                                     {/* <FontAwesomeIcon className="fontawesomIcons" icon={faBars} /> */}
                                    
//                                         {navDrop ?
//                                     <FontAwesomeIcon className="fontawesomIcons" icon={faTimes} />:
//                                     <FontAwesomeIcon className="fontawesomIcons" icon={faBars} />
//                                     }
//                                 </div>

//                                 </li>

//                                 <li className='serviceItem'><Link to={"/Courseswhole"} className='linkItem'>Courses</Link></li>
//                                 <li className='serviceItem'><Link to={"/Organisations"} className='linkItem'>For Organisations</Link></li>
//                                 <li className='serviceItem'><Link to={"/Home"} className='linkItem'>Dashboard</Link></li>
//                                 <li className='serviceItem'><Link to={"/MoreInfo"} className='linkItem'>More Info</Link></li>
//                                 {auth?.Role == 'Admin' &&   
//                                     <li className='serviceItem'><Link to={"/admin/applicants"} className='linkItem'>Admin  </Link></li>
//                                 }
                                
                                
//                         </ul>

//                     </div>
//                     <div className='thirdItem'> 
                                    
//                         <li>

//                                 <div className='buttons'>   
//                                     {auth.user?
//                                             <div className="loggedBtn"> 
//                                                 <h3  onClick={()=>{setLogout(!logout)}}>
//                                                         {String(auth?.FName)}
//                                                         <FontAwesomeIcon className='fontLogoutICon' icon={faChevronDown} />
//                                                 </h3>
//                                                 { logout &&
//                                                         <div className='logoutBtn'> 
//                                                             <p><Link to={'/profile'} className='listItem'>Profile |</Link> </p>
//                                                             <p onClick={()=>HandleLogout()}>LOGOUT</p>
//                                                         </div>
//                                                 }
//                                                 </div>
                                                
//                                                 :

                                               
//                                                    <Link to={"/login"} className='linkItem'><button>LOGIN</button></Link>
                                                

                                               

//                                             }
                           
                                    
                                    
//                                 </div>

//                         </li>

//                     </div>
                

//                 </div>
//                 <div className= {navDrop?'dropView':"noDrop"} >
                
                    

//                 </div>
//                 {/* response drop nav */}
//                 {/* <div className='SecResDrop'> */}
//                 <div className= {navDropSec?'SecResDrop':"noSecDrop"}>
//                     <div className='secDropCover'>

//                                 <ul>
//                                     <li><Link to={"/Courseswhole"} className='linkItem'>Courses</Link></li>
//                                     <li><Link to={"/Organisations"} className='linkItem'>For Organizations</Link></li>
//                                     <li><Link to={"/Home"} className='linkItem'>Insights</Link></li>
//                                     <li><Link to={"/MoreInfo"} className='linkItem'>More Info</Link></li>
//                                     <li><Link to={"/"} className='linkItem'>Alumni</Link></li>
                                   
//                                     <li><Link to={"/login"} className='linkItem'><button>APPLY NOW</button></Link></li>
                                
                                
//                                 </ul>

//                     </div>
                  

//                 </div>
                
//     </div>
  
//   </>
  
//   ;
// }

// export default NavBar;